var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10156 5L12.7734 5C14.0031 5 15 5.99687 15 7.22656L15 15.8984C15 17.1281 14.0031 18.125 12.7734 18.125L4.10156 18.125C2.87187 18.125 1.875 17.1281 1.875 15.8984L1.875 7.22656C1.875 5.99687 2.87187 5 4.10156 5Z",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01953 5L5 4.0625C5.00165 3.48285 5.23265 2.9274 5.64253 2.51753C6.05241 2.10765 6.60785 1.87665 7.1875 1.875L15.625 1.875C16.2874 1.87696 16.9222 2.14098 17.3906 2.6094C17.859 3.07781 18.123 3.71256 18.125 4.375L18.125 12.8125C18.1234 13.3922 17.8924 13.9476 17.4825 14.3575C17.0726 14.7674 16.5172 14.9984 15.9375 15L15 15M8.4375 8.4375L8.4375 14.6875M5.3125 11.5625L11.5625 11.5625",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/Duplicate.f5174d53022d97926d9da44ee229c857.svg";
export { ForwardRef as ReactComponent };